
import React, { useState } from 'react';
import { useGame } from '@/app/providers/GameContextProvider';
import { GameMapProvider } from '@/app/providers/GameMapContextProvider';
import { GuessProvider } from '@/app/providers/GuessContextProvider';
import dynamic from 'next/dynamic';
import RoundTimer from './RoundTimer';
import CoopRoleIndicator from './CoopRoleIndicator';
import { GameMode } from '@/lib/types/common/GameMode';
import { CoopRole } from '@/lib/types/common/Player';
import { useIsMobile } from '@/hooks/useIsMobile';
import { FaMap } from 'react-icons/fa';
import { motion } from 'framer-motion';
const GameMapEor = dynamic(() => import("@/app/components/MapEor/GameMapEor"), { ssr: false });

interface GamePlayProps {
    countdownComplete?: boolean;
}

const GamePlay = ({ countdownComplete = true }: GamePlayProps) => {
    const { gameState, players } = useGame();
    const isMobile = useIsMobile();
    const [isMapOpen, setIsMapOpen] = useState(false);



    // Get current player uniqueId from localStorage
    let currentPlayer: typeof players[0] | undefined = undefined;
    if (typeof window !== 'undefined') {
        const uniqueId = localStorage.getItem('playerUniqueId');
        if (uniqueId) {
            currentPlayer = players.find(p => p.uniqueId === uniqueId);
        }
    }

    if (!gameState || !currentPlayer) return null;

    const isEliminated = currentPlayer?.isEliminated;
    const isCoopMode = gameState?.gameMode === GameMode.COOP ||
        (gameState?.gameMode === GameMode.CUSTOM && gameState?.gameSettings?.baseMode === GameMode.COOP);
    const isPhotosphereRole = isCoopMode && currentPlayer.coopRole === CoopRole.PHOTOSPHERE;
    const canSeeMap = !isPhotosphereRole && !isEliminated

    return (
        <GameMapProvider>
            <GuessProvider>
                {countdownComplete && (<RoundTimer />)}
                {isCoopMode && <CoopRoleIndicator />}
                {canSeeMap && (
                    isMobile ? (
                        <>
                            {/* Mobile Map Button */}
                            <div className="absolute bottom-4 right-4 flex z-[40]">
                                <div
                                    className="h-[70px] w-[70px] cursor-pointer rounded-[100%] flex items-center justify-center shadow-[0_0_3px_1px_rgba(0,0,0,0.5),inset_0_0_3px_1px_rgba(0,0,0,0.5)] hover:bg-[#6F6F6F] bg-[#575757] border-2 border-x-[#c0a270] border-y-[#e0c290] group"
                                    onClick={() => setIsMapOpen(!isMapOpen)}
                                >
                                    <FaMap className="text-3xl text-[#bea881]" />
                                </div>
                            </div>
                            {/* Mobile Map Modal */}
                            <motion.div
                                initial={{ y: "100%" }}
                                animate={{ y: isMapOpen ? "0%" : "100%" }}
                                className="fixed inset-0 z-[10001]"
                                onClick={() => setIsMapOpen(false)}
                            >
                                <div
                                    className="absolute bottom-0 left-0 right-0 p-2"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <GameMapEor onClose={() => setIsMapOpen(false)} />
                                </div>
                            </motion.div>
                        </>
                    ) : (
                        <GameMapEor />
                    )
                )}
            </GuessProvider>
        </GameMapProvider>
    );
}

export default GamePlay